/**
 * 个人中心
 *  */

/** 我的月卡 */
export const MERBERMONTHCARDQUERY = "MERBERMONTHCARDQUERY"  // 用户月卡列表

/** 我的车辆 */
export const MERBERCARQUERY = "MERBERCARQUERY"        // 车辆列表
export const MERBERCARUPDATE = "MERBERCARUPDATE"  // 修改我的车辆
export const MERBERCARDELETE = "MERBERCARDELETE"  // 解绑车辆
export const ISNOSENSEUPDATE = "ISNOSENSEUPDATE"  // 无感支付开关

/** 我的优惠券 */
export const MERBERCOUPONSQUERY = "MERBERCOUPONSQUERY"  // 我的优惠券列表
export const MERBERCOUPONSQUERYLEN = "MERBERCOUPONSQUERYLEN"  // 我的-我的优惠券数量

/** 我的账单 */
export const MYBILLQUERY = "MYBILLQUERY"  // 我的账单列表

export const WECHATNOTICE = "WECHATNOTICE"  // 车场监控
export const PARKUNBUNDING = "PARKUNBUNDING"  // 车场监控

export const COUPON = "COUPON"
export const DAYREPORT = "DAYREPORT"
export const MONTHREPORT = "MONTHREPORT"



// WEBPACK FOOTER //
// ./src/store/mine/types.js